export default __webpack_public_path__ + "static/media/culture-reward-placeholder.7c571503.svg";